var React = require('react');

function Back (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m.29292501 7.6563625c-.39050001.3904-.39060001 1.0236-.0001 1.4142l6.36349999 6.36439c.3905.39056 1.0237.3906 1.4142.00011.3906-.3905.3906-1.02366.0001-1.41422l-5.6564-5.65728 5.6572-5.6564c.3906-.3905.3906-1.0237.0002-1.4142-.3905-.3906-1.0237-.3906-1.4143-.0001zm19.42545999 12.750643.000027-7.042583h-2l-.000027 7.042583zm-5.99953-13.042643-12.71893-.0009v2l12.71878.0009zm5.999557 6.00006c0-3.31356-2.686017-5.99976-5.999557-6.00006l-.00015 2c2.20903.0002 3.99972 1.79103 3.999707 4.00006z","fill":"#bae360","transform":"translate(.107512 -.317843)"}));
}

Back.defaultProps = {"height":"21","viewBox":"0 0 20 21","width":"20"};

module.exports = Back;

Back.default = Back;
